<template>
  <div class="logNotice">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane v-for="item in tabArray" :key="item.name" :label="$t(item.label)" :name="item.name"></el-tab-pane>
    </el-tabs>
    <component :is="activeName"></component>
    
  </div>
</template>

<script>

import logEmail from './components/logEmail.vue';
import logMessage from './components/logMessage.vue';
import logVoice from './components/logVoice.vue'

export default {
  components: {
    logEmail,
    logMessage,
    logVoice
  },

  data() {
    return {
      activeName: 'logEmail',
      tabArray: [
        {
          label: this.$t('noticelog.log_email'),
          name: 'logEmail'
        },
        {
          label: this.$t('noticelog.log_sms'),
          name: 'logMessage'
        },
        {
          label: this.$t('noticelog.log_voice'),
          name: 'logVoice'
        }
      ]
    }
  },
  methods: {
    handleClick() { }
  }
}
</script>

<style lang="scss" scoped>
.logNotice {
  height: 100%;
  padding: 0 15px;
  padding-top: 10px;
  box-sizing: border-box;
}
</style>